import {
  TRANSACTION_FETCH_FAIL,
  TRANSACTION_FETCH_REQUEST,
  TRANSACTION_FETCH_SUCCESS,
} from "../constants/transactionConstants";
import axios from "../../customAxios";

export const fetchTransactions = (page = 1, limit = 10,search) => async (dispatch) => {
  try {
    dispatch({ type: TRANSACTION_FETCH_REQUEST });

    const { data } = await axios.get(`/api/v1/admin/getAllTransactions?page=${page}&limit=${limit}&search=${search}`);

    dispatch({ type: TRANSACTION_FETCH_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: TRANSACTION_FETCH_FAIL,
      payload:
        error.response?.data?.message || error.message || "Something went wrong",
    });
  }
};